(() => {
  if (customElements.get('header-dropdown')) {
    return;
  }

  class HeaderDropdown extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('[data-button-action]');
    }

    connectedCallback() {
      this.button.addEventListener('click', this.toggle.bind(this));
    }

    toggle(e) {
      e.preventDefault();
      this.button.classList.toggle('open');
    }
  }

  customElements.define('header-dropdown', HeaderDropdown);
})();
